import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { PERSONALITY_CHANGE_TOKEN } from "@/shared/const/storageKeys";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

interface Params {
  personalityIds: number[];
  shouldUseToken?: boolean;
}

interface Response {
  id: number;
  user: number;
  personality: number;
  created_at: string;
}

export const changePersonalities = createAsyncThunk<Response, Params, ThunkConfig<ApiError>>(
  "personality/changePersonalities",
  async ({ personalityIds, shouldUseToken }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      // customer can change personality for free (after registration) but only once
      const personalityChangeToken = localStorage.getItem(PERSONALITY_CHANGE_TOKEN);

      const response = await extra.api.post<Response>("/api/user-assigned-personalities", {
        personality_ids: personalityIds,
        personality_change_token: shouldUseToken && !!personalityChangeToken ? personalityChangeToken : undefined,
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
